import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.2.37_react@18.2.0__@emotion+style_5i2g3t7dd4fhwkokw7gke774vq/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Spin/Spinner.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/privacy-policy-page/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/shared/typography/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/translations/client-setup.ts");
